import { extendObservable } from 'mobx';

class DisclosureStore {
  constructor(railsProps) {
    extendObservable(this, {
      buttonText: railsProps.button_text || '*View full terms and conditions.',
      className:
        railsProps.class_name || 'thunderbird-text font-semibold fs-xs',
      disclosureModalOpen: false,
    });
  }

  openDisclosureModal = () => {
    this.disclosureModalOpen = true;
  };

  closeDisclosureModal = () => {
    this.disclosureModalOpen = false;
  };
}

export default DisclosureStore;
